import { Button, colors, DeprecatedPreview, Icon } from '@neshane/blueberry';

const HelpTooltip = ({ questions, onClose, ticketsHref = '/tickets' }) => {
  return (
    <div className="w-[482px] overflow-hidden rounded-12">
      <div className="flex items-center gap-16 p-16">
        <Icon
          name="circle-question-outline"
          size="l"
          color={colors.contentAlertDefault}
          aria-hidden="true"
        />
        <div className="text-primary title-m">راهنمایی و پشتیبانی</div>
      </div>
      <div className="bg-primary-default p-16 pb-24">
        <div className="flex flex-col gap-4">
          {questions.map((question) => (
            <DeprecatedPreview
              key={question.title}
              fit="parent"
              primaryText={question.title}
              rightAddon={<Icon aria-hidden="true" name="chevron-left" />}
              onClick={() => {
                onClose();
                window.location.assign(question.link);
              }}
            />
          ))}
        </div>
        <div className="mt-8 flex items-center justify-between">
          <a
            href={ticketsHref}
            className="flex items-center justify-center gap-4 text-primary title-m hover:text-primary"
            onClick={onClose}
          >
            <Icon name="arrow-left" size="s" aria-hidden="true" />
            <span>بیشتر بدانید</span>
          </a>
          <Button
            variant="tertiaryNeutral"
            text="تماس با پشتیبانی"
            onClick={() => {
              onClose();
              window.location.assign(ticketsHref);
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default HelpTooltip;